import { ArrowLeftIcon, ArrowRightIcon } from '@cloudclevr/components';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  setPageNumber: (pageNumber: number) => void;
  testId?: string;
};

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  setPageNumber,
  testId,
}) => {
  const btnBaseClasses =
    'flex h-8 w-8 items-center justify-center rounded-full';
  const btnEnabledClasses = 'cursor-pointer bg-interfaceColor-90';
  const btnDisabledClasses = 'cursor-not-allowed bg-interfaceColor-30';

  const handleNextPage = () => {
    setPageNumber(currentPage + 1);
  };

  const handlePrevPage = () => {
    setPageNumber(Math.max(currentPage - 1, 1));
  };

  const getTestId = (suffix: string, fallback: string) => {
    if (testId) {
      return `${testId}-${suffix}`;
    }

    return fallback;
  };

  return (
    <>
      <div data-testid={getTestId('info', 'pagination-info')}>
        Page {currentPage} of {totalPages}
      </div>
      <div className="flex space-x-2">
        <button
          data-testid={getTestId('prev-button', 'prevbtn')}
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          aria-label="Previous page"
          title="Previous page"
          className={`${btnBaseClasses} ${
            currentPage === 1 ? btnDisabledClasses : btnEnabledClasses
          }`}
        >
          <ArrowLeftIcon
            size="2"
            classNames={`${
              currentPage === 1 ? 'text-interfaceColor-60' : 'text-white'
            }`}
          />
        </button>

        <button
          data-testid={getTestId('next-button', 'nextbtn')}
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          aria-label="Next page"
          title="Next page"
          className={`${btnBaseClasses} ${
            currentPage === totalPages ? btnDisabledClasses : btnEnabledClasses
          }`}
        >
          <ArrowRightIcon
            size="2"
            classNames={`${
              currentPage === 1 ? 'text-interfaceColor-60' : 'text-white'
            }`}
          />
        </button>
      </div>
    </>
  );
};
